import Vue from "vue"
import Vuex from "vuex"

import parameters from "./modules/parameters"
import dc4 from "./modules/dc4"
import dictionary from "./modules/dictionary"
import form from "./modules/form"
import lxd from "./modules/lxd"
import lxi from "./modules/lxi"
import pd0 from "./modules/pd0"
import pd1 from "./modules/pd1"
import pd2 from "./modules/pd2"
import cashier from "./modules/cashier"
import vd1 from "./modules/vd1"
import vdk from "./modules/vdk"
import cf6 from "./modules/cf6"
import cf1 from "./modules/cf1"
import pr0 from "./modules/pr0"
import fnl from "./modules/fnl"
import cf2 from "./modules/cf2"
import cv2 from "./modules/cv2"
import cv6 from "./modules/cv6"
import cf5 from "./modules/cf5"
import fiscal from "./modules/fiscal"
import lxa from "./modules/lxa"
import lxq from "./modules/lxq"
import vd4 from "./modules/vd4"
import pd5 from "./modules/pd5"
import print from "./modules/print"
import lxe from "./modules/lxe"
import lxh from "./modules/lxh"
import pd6 from "./modules/pd6"
import pd7 from "./modules/pd7"
import lx2 from "./modules/lx2"
import lx3 from "./modules/lx3"
import lx0 from "./modules/lx0"
import vde from "./modules/vde"
import cx0 from "./modules/cx0"
import lx1 from "./modules/lx1"
import co1 from "./modules/co1"
import cv5 from "./modules/cv5"
import cv8 from "./modules/cv8"
import pd3 from "./modules/pd3"
import ve0 from "./modules/ve0"
import ve1 from "./modules/ve1"
import ve2 from "./modules/ve2"
import ve3 from "./modules/ve3"
import cf3 from "./modules/cf3"
import cfe from "./modules/cfe"
import cf7 from "./modules/cf7"
import cv1 from "./modules/cv1"
import pd8 from "./modules/pd8"
import wha from "./modules/wha"
import lxf from "./modules/lxf"
import lxg from "./modules/lxg"
import et3 from "./modules/et3"
import cvx from "./modules/cvx"
import pr3 from "./modules/pr3"
import fv2 from "./modules/fv2"
import ve4 from "./modules/ve4"
import sales from "./modules/sales"
import stock from "./modules/stock"
import report from "./modules/report"
import consignment from "./modules/consignment"
import scheduler from "./modules/scheduler"
import nfexml from "./modules/nfexml"

import gr0 from "./modules/gr0"
import et0 from "./modules/et0"
import fi0 from "./modules/fi0"
import co0 from "./modules/co0"
import prs from "./modules/prs"
import prb from "./modules/prb"
import cr1 from "./modules/cr1"
import of3 from "./modules/of3"
import cvn from "./modules/cvn"
import ean from "./modules/ean"

import cf4 from "./modules/cf4"
import cfc from "./modules/cfc"
import cfa from "./modules/cfa"
import cvs from "./modules/cvs"
import gnr from "./modules/gnr"
import est from "./modules/est"
import cf8 from "./modules/cf8"
import cff from "./modules/cff"
import cfb from "./modules/cfb"
import cfd from "./modules/cfd"
import cf0 from "./modules/cf0"
import me1 from "./modules/me1"
import me2 from "./modules/me2"
import in1 from "./modules/in1"
import cvm from "./modules/cvm"
import pr2 from "./modules/pr2"
import gr1 from "./modules/gr1"
import cvf from "./modules/cvf"
import cb0 from "./modules/cb0"
import cb1 from "./modules/cb1"
import cv3 from "./modules/cv3"
import cx1 from "./modules/cx1"
import ofh from "./modules/ofh"
import ofg from "./modules/ofg"
import fn5 from "./modules/fn5"
import of1 from "./modules/of1"
import ofp from "./modules/ofp"
import ofq from "./modules/ofq"
import ofr from "./modules/ofr"
import ofs from "./modules/ofs"
import oft from "./modules/oft"
import med from "./modules/med"
import lx8 from "./modules/lx8"
import me9 from "./modules/me9"
import lxk from "./modules/lxk"
import ofv from "./modules/ofv"
import ofw from "./modules/ofw"
import ofy from "./modules/ofy"
import lod from "./modules/lod"
import mpv from "./modules/mpv"
import lxl from "./modules/lxl"
import pj0 from "./modules/pj0"
import da1 from "./modules/da1"
import in0 from "./modules/in0"
import loe from "./modules/loe"
import cfh from "./modules/cfh"
import lxj from "./modules/lxj"
import eqp from "./modules/eqp"
import eqc from "./modules/eqc"
import ofz from "./modules/ofz"
import meb from "./modules/meb"
import vea from "./modules/vea"
import veb from "./modules/veb"
import commission from "./modules/commission"
import fn9 from "./modules/fn9"
import fn8 from "./modules/fn8"
import fnb from "./modules/fnb"
import mb0 from "./modules/mb0"
import mb1 from "./modules/mb1"
import mb2 from "./modules/mb2"
import fic from "./modules/fic"
import fid from "./modules/fid"
import movementTitles from "./modules/movementTitles"
import vd0 from "./modules/vd0"
import vdq from "./modules/vdq"
import vdp from "./modules/vdp"
import vdt from "./modules/vdt"
import att from "./modules/att"
import inc from "./modules/inc"
import fm1 from "./modules/fm1"
import inf from "./modules/inf"
import materialReceiving from "./modules/materialReceiving"
import dr3 from "./modules/dr3"
import dr4 from "./modules/dr4"
import launchImport from "./modules/launchImport"
import in6 from "./modules/in6"
import lxr from "./modules/lxr"
import lx6 from "./modules/lx6"
import lx7 from "./modules/lx7"
import fn1 from "./modules/fn1"
import fnc from "./modules/fnc"
import fn3 from "./modules/fn3"
import fn3a from "./modules/fn3a"

Vue.use(Vuex)

export default new Vuex.Store({
	modules: { parameters, dc4, dictionary, lxd, lxi, form, pd0, pd1, pd2, cashier, vd1, vdk, cf6, cf1, cf5, pr0, fnl, cf2, cv2, cv6, fiscal, lxa, vd4, pd5, print, lxe, pd6, pd7, lx2, lx3, lx0, vde, consignment, cx0, lx1, co1, cv5, pd3, ve0, ve1, ve2, cfe, cf7, cv1, pd8, wha, lxf, lxg, et3, cvx, pr3, ve3, fv2, ve4, cf3, cf4, cfc, cfa, cvs, cff, cf8, cfb, cfd, cf0, gnr, est, me1, me2, in1, cvm, sales, stock, report, scheduler, ean, cvn, of3, cr1, prb, prs, co0, fi0, et0, gr0, gr1, pr2, cvf, lxh, cb0, cb1, cx1, cv3, ofh, ofg, of1, ofp, ofq, ofr, ofs, oft, med, cv8, fn5, lxq, lxk, ofv, ofw, ofy, lxl, lod, mpv, me9, lx8, pj0, lxj, da1, in0, loe, cfh, meb, vea, veb, commission, fn9, fn8, fnb, fic, fid, vdt, inc, fm1, inf, nfexml, vd0, vdq, vdp, materialReceiving, att,  in6, lxr, lx6, lx7, fn1, fnc, fn3, fn3a, dr3, dr4, launchImport, mb0, mb1, mb2, movementTitles, eqp, eqc, ofz },
})
